import type { ReactNode } from 'react';

export default function EmptyState({ icon = '🗂️', title, children }: { icon?: ReactNode; title: ReactNode; children?: ReactNode }) {
  return (
    <div className="empty">
      <div className="em" aria-hidden>{icon}</div>
      <b>{title}</b>
      {children && <div className="small">{children}</div>}
    </div>
  );
}
